<template>
  <f7-page name="sim-status">
    <!-- Top Navbar -->
    <f7-progressbar v-if="isLoading || isLoadingCSP || isLoadingCustomer" infinite color="green" class="progressbar-top"></f7-progressbar>
    <f7-navbar  :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('SimInfo') }}</f7-nav-title>
      <f7-nav-right>
        <label :for="inputSubmitId" class="link icon-only">
          <i class="icon f7-icons">checkmark_alt</i>
        </label>
        <!--<f7-link @click="openDialogChangeStatus(simInfo)" icon="icon-notification text-color-red" :class="{disabled: isHandled}"></f7-link>
        <f7-link :href="`/asset-position/?name=${ simInfo.AS_NAME }&imei=${ simInfo.EHLOG_AS_IMEI }`" icon="icon-position"></f7-link>-->
      </f7-nav-right>

    </f7-navbar>

    <f7-toolbar v-if="simInfo && !isNoData" bottom class="custom-toolbar bg-color-white" key="sim-bottom-toolbar-key">
      <div class="row width-100 padding-horizontal">
        <f7-button @click="openLocation()" color="green" fill class="col">{{ $t('Locate') }}</f7-button>
        <f7-button @click="changeSimState('resume')" color="blue" fill class="col" :class="{disabled: isChangeStateOptionDisabled('resume')}">{{ $t('Resume') }}</f7-button>
        <f7-button @click="changeSimState('suspend')" color="orange" fill class="col" :class="{disabled: isChangeStateOptionDisabled('suspend')}">{{ $t('Suspend') }}</f7-button>
        <f7-button @click="changeSimState('terminate')" v-if="IS_ROOT" color="red" fill class="col" :class="{disabled: isChangeStateOptionDisabled('terminate')}">{{ $t('Terminate') }}</f7-button>
      </div>
    </f7-toolbar>

    <f7-block v-if="!simInfo && isNoData">
      <p>{{ $t('NoDataFound') }}</p>
    </f7-block>

    <f7-list v-else-if="!simInfo" no-hairlines>
      <f7-list-item
          header="header"
          title="simInfo.IMSI"
          class="skeleton-text skeleton-effect-blink"
          v-for="n in 4"
          :key="n"
      >
        <template #media>
          <f7-skeleton-block style="width: 40px; height: 40px; border-radius: 100%"></f7-skeleton-block>
        </template>

      </f7-list-item>
    </f7-list>

    <form v-else action="" @submit.prevent="onSubmit">
      <input type="submit" :id="inputSubmitId" hidden >
      <f7-list no-hairlines>
        <f7-list-item
            :header="$t('IMSI')"
            :title="simInfo.IMSI"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-other-imei text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item
            :header="$t('ICCID')"
            :title="simInfo.ICCID ? simInfo.ICCID : $t('na')"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-other-imei text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item
            :header="$t('MSISDN')"
            :title="simInfo.MSISDN ? simInfo.MSISDN : $t('na')"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-other-imei text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>
        <!--<f7-list-item
            :header="$t('Customer')"
            :title="simInfo.OrganizeName ? simInfo.OrganizeName : $t('na')"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item
            :header="$t('CSP')"
            :title="simInfo.ServiceProfileName ? simInfo.ServiceProfileName : $t('na')"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-other-language text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>-->
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Customer')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyCustomerList'+keyCustomerList"
            :class="{'disabled': !IS_ROOT || isLoadingCustomer}"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
          </template>
          <select name="CustomerList" v-model="CustomerCode">
            <option
                v-for="csp in CustomerList"
                :key="csp.Code"
                :value="csp.Code"
            >{{csp.Name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('CSP')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyCSPList'+keyCSPList"
            :class="{'disabled': !IS_ROOT || isLoadingCSP}"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-other-language text-color-lightgray"></f7-icon>
          </template>
          <select name="CSPList" v-model="CSPCode">
            <option
                v-for="csp in CSPList"
                :key="csp.Code"
                :value="csp.Code"
            >{{csp.Name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            :header="$t('State')"
            :title="simInfo.State ? simInfo.State : $t('na')"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-sim-status text-color-lightgray"
                    :class="simIconColorClass"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item
            :header="$t('LastStateUpdate')"
            :title="simInfo.StateUpdateTime ? dateFormat(simInfo.StateUpdateTime+'+0000', 'datetime') : $t('na')"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-year text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item
            :header="$t('TotalSMS')"
            :title="simInfo.TotalSMSMO + ' / ' + simInfo.TotalSMSMT"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-sms text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item
            :header="$t('DataUsed')"
            :title="numeralFormat(simInfo.DataDay, '0.0 b') + ' / ' + numeralFormat(simInfo.DataWeek, '0.0 b') + ' / ' + numeralFormat(simInfo.DataMonth, '0.0 b')"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-data text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item
            :header="$t('Sessions')"
            :title="numeralFormat(simInfo.SessionDay) + ' / ' + numeralFormat(simInfo.SessionWeek) + ' / ' + numeralFormat(simInfo.SessionMonth)"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-other-gsm text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item
            :header="$t('LastDataUpdate')"
            :title="simInfo.DataUpdateTime ? dateFormat(simInfo.DataUpdateTime+'+0000', 'datetime') : $t('na')"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-year text-color-lightgray"></f7-icon>
          </template>
        </f7-list-item>

      </f7-list>
    </form>

  </f7-page>
</template>

<script>

import { QTAPI } from "../../services/qt-api";
import { f7 } from 'framework7-vue';
import { dateFormat } from "../../js/helpers";
import {mapGetters} from "vuex";

export default {
  name: "sim-status",

  props: {
    f7router: Object,
    f7route: Object,
  },

  data() {
    return {
      inputSubmitId: f7.utils.id(),
      isLoading: false,
      isNoData: false,
      isLoadingCSP: false,
      isLoadingCustomer: false,
      simInfo: null,
      keyCSPList: 1,
      keyCustomerList: 1,
      CSPCode: null,
      CustomerCode: null,
      CSPList: [],
      CustomerList: [],
    }
  },

  computed: {
    ...mapGetters(['IS_ROOT', 'MajorToken', 'MinorToken']),
    simIconColorClass(){
      let ret = "text-color-lightgray"
      switch (this.simInfo.State){
        case 'Productive':
        case 'TestProductive':
          ret = "text-color-green"
          break;
        case 'Suspended':
          ret = "text-color-orange"
          break;
        case 'Deleted':
          ret = "text-color-red"
          break;
      }
      return ret
    }
  },

  async mounted() {
    this.getSimStatus()
    this.getCSP()
    this.getCustomer()
  },

  methods: {
    async onSubmit(){
      this.isLoadingSave = true;

      if(this.CustomerCode){
        let data = {
          IMSIs: [this.simInfo.IMSI],
					toorganizecode: this.CustomerCode,
					Number: '',
					Remark: ''
        }
        let response = await QTAPI.SetCustomer(data)
        if (!response){
          f7.dialog.alert(this.$t('CustomerChangingError'), this.t('Error'))
        }
      }
      if(this.CSPCode){
        let data = {
          IMSIs: [this.simInfo.IMSI],
          ServiceProfileCode: this.CSPCode
        }
        let response = await QTAPI.SetCSP(data)
        if (!response){
          f7.dialog.alert(this.$t('CSPChangingError'), this.t('Error'))
        }
      }

      this.isLoadingSave = false;
      this.$store.commit('SIM_UPDATED')
      f7.notification.create({
        subtitle: this.$t('Success'),
        text: this.$t('DataUpdated'),
      }).open()
      this.f7router.back()
    },
    dateFormat(...options){
      return dateFormat(...options)
    },
    isChangeStateOptionDisabled(action){
      let ret = false
      if(this.simInfo.State === 'Suspended'){
        if(action === 'suspend') ret = true
      }else if(this.simInfo.State === 'Productive' || this.simInfo.State === 'TestProductive' || this.simInfo.State === 'Test' || this.simInfo.State === 'Deleted'){
        if(action === 'resume') ret = true
      }else if(this.simInfo.State === 'OnStock'){
        if(action === 'resume') ret = true
        if(action === 'suspend') ret = true
        if(action === 'testProductive') ret = true
        if(action === 'terminate') ret = true
      }
      return ret
    },
    async getCustomer() {
      this.isLoadingCustomer = true
      let list = []
      let page = 1
      let isLast = false
      let requestLimit = 100
      let pageSize = 100

      while ( !isLast ) {
        let result = await QTAPI.GetSimOwners({
          Page: page,
					Rows: pageSize,
					IncludeSelf: true,
					Order: 'ASC',
					Sort: 'Name',
        });
        let owners = result.rows
        if(!owners || !Array.isArray(owners)){
          isLast = true
          break
        }
        page++
        if(owners.length){
          list = [...list, ...owners]
        }
        if(!owners.length || owners.length < pageSize || page === requestLimit){
          isLast = true
        }
      }

      this.isLoadingCustomer = false
      this.isNoData = !list.length

      this.CustomerList = list
      this.keyCustomerList++
    },
    async getCSP(){
      this.isLoadingCSP = true;
      let csp = await QTAPI.GetCSP({})
      this.isLoadingCSP = false;
      if(!csp){
        return
      }
      this.CSPList = csp.Data
      this.keyCSPList++
    },
    async getSimStatus() {
      if(!this.f7route.query.imsi){
        this.isNoData = true
        f7.dialog.alert(this.$t('MissingIMSI', this.$t('Error')))
        return
      }

      this.isLoading = true
      let data = {
        IMSIs: this.f7route.query.imsi
      }
      let response = await QTAPI.GetSimStatus(data)
      this.isLoading = false
      if (!response || !response.rows || !response.rows.length) {
        this.isNoData = true
        f7.dialog.alert(this.$t('IMSINotFound', { imsi: data.IMSIs }), this.$t('Error'))
        return
      }

      this.simInfo = response.rows[0]
      this.CSPCode = this.simInfo.ServiceProfileCode
      this.CustomerCode = this.simInfo.OrganizeCode
    },
    openLocation(){
      f7.views.main.router.navigate({
        name: 'sim-position',
        query: { imsi: this.f7route.query.imsi }
      })
    },
    async changeSimState(action){
      if(!action){
        return
      }

      let data = {
        IMSIs: this.f7route.query.imsi
      }

      let response = null
      this.isLoading = true
      if(action === 'resume'){
        response = await QTAPI.SimSetResume(data)
      }
      if(action === 'suspend'){
        response = await QTAPI.SimSetSuspend(data)
      }
      if(action === 'terminate'){
        response = await QTAPI.SimSetTerminate(data)
      }
      this.isLoading = false
      if(!response){
        return
      }
      f7.dialog.alert(this.$t('SimStatusChanged'), this.$t('Success'))
      setTimeout(()=>{
        this.getSimStatus()
      }, 500)

    }
  }
}
</script>

<style scoped>

</style>